import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import './nav.css'

const Nav = (props) => {
  return (
    <div className='page-nav'>
      <div className='row'>
        <div className='col-xs-6'>
          <span>Prev</span>
          <Link to={props.prev.href}>{props.prev.label}</Link>
        </div>
        <div className='col-xs-6'>
          <span>Next</span>
          <Link to={props.next.href}>{props.next.label}</Link>
        </div>
      </div>
    </div>
  )
}

Nav.propTypes = {
  prev: PropTypes.object,
  next: PropTypes.object
}

export default Nav



// WEBPACK FOOTER //
// ./src/components/Page/Nav/index.js